import { type CardEntityId } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { cardKey } from './keys'

export type CardCache = {
  clearItem: (entityId: CardEntityId) => void
}

export function useCardCache(): CardCache {
  const queryClient = useQueryClient()

  function clearItem(entityId: CardEntityId): void {
    queryClient.invalidateQueries({ queryKey: cardKey(entityId) })
  }

  return { clearItem }
}
